import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { AutoComplete } from 'antd'

@inject((store: any) => {
    const { nameList, setSelected, setValue, selected, value } = store.providerStore
    return { nameList, setSelected, setValue, selected, value }
})
@observer
class ProviderSelect extends Component<any, any> {
    componentDidMount() {
        this.handleSelect()
    }
    handleChange = value => {
        this.props.setValue(value)
    }
    handleSelect = async () => {
        await this.props.setSelected()
        if (this.props.providerSelected) {
            this.props.providerSelected()
        }
    }
    render() {
        const { nameList, disable, setValue, value } = this.props
        return (
            <AutoComplete
                style={{ width: '100%' }}
                disabled={disable}
                value={value ? value : undefined}
                dataSource={nameList ? nameList : []}
                placeholder="הקלד את שם המעסיק"
                onChange={value => setValue(value)}
                onSelect={() => this.handleSelect()}
                filterOption={(inputValue, option) =>
                    option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                }
            />
        )
    }
}

export default ProviderSelect
